module.exports = __webpack_public_path__ + "img/image-6.04a2b5f9.jpg";